export default __webpack_public_path__ + "static/media/crowded-user-menu.df63352d.png";